import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalWrapperComponent } from '@myapp/features/widgets/components';
import { BaseEditorComponent } from '../base-editor/base-editor.component';
import { InstanceConfigForm } from './instance-configuration.form';

import { SharedUICheckboxComponent, SharedUiDropdownComponent, SharedUiTextInputComponent } from '../../../../modules/forms';

@Component({
  selector: 'app-instance-editor',
  templateUrl: './instance-configuration-editor.component.html',
  styleUrls: ['./instance-configuration-editor.component.scss'],
  standalone: true,
  imports: [ModalWrapperComponent, FormsModule, SharedUiTextInputComponent, SharedUiDropdownComponent, SharedUICheckboxComponent]
})
export class InstanceEditorComponent extends BaseEditorComponent {
  @Input() form?: InstanceConfigForm;

  ngOnInit() {
    super.ngOnInit();
  }

}
